// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m8TG","content":"styles_content__1nfk0","row":"styles_row__180YM","footer":"styles_footer__2N5Mm","phraseLength":"styles_phraseLength__1UQDI"};